module.exports = __webpack_public_path__ + "static/media/rbl-bank-logo.d4633e8e.png";